<template>
    <div>
        <sammio-actions mobileNavText="saados" @drawer="setDrawerStatus" :isMobile="getMobileStatus" icon="statutes" :status="getDrawerStatus"></sammio-actions>
        <div class="container">
            <div class="row">
                <aside v-if="!getMobileStatus" class="col-md-4 bg-white pt-3" ref="sticky__wrapper" id="sammio__element--aside">
                    <div class="sammio__intersect--marker" v-intersect="onIntersect"></div>
                    <div id="sammio__container--aside" ref="stickyContent" :class="!isIntersecting ? '' : 'v-sticky--element'">
                            <div :class="isIntersecting ? 'sammio__container--scrollable' : '' " :style="isIntersecting ? 'width:'+ (this.stickyWidth - 12) + 'px' : '' ">
                                <h4  class="sammio-panels__title">{{$t('sammio.statutes.title')}}</h4>
                                <v-expansion-panels
                                        accordion
                                        tile
                                        v-model="openPanels"

                                >
                                    <v-expansion-panel
                                            v-for="(statute,i) in statutes"
                                            :key="'dt-' + i"
                                    >
                                        <v-expansion-panel-header
                                                hide-actions
                                                @click="onNavClick(i + 1, 1)"
                                                :aria-expanded="i == openPanels ? 'true' : 'false'"
                                                :aria-current="isStatuteActive(i) && statute.chapters.length == 1 ? 'location' : 'false'"
                                        >
                                            {{statute.name}}
                                            <span role="presentation" class="sammio-icon">
                                            <chevron-down-icon size="1.5x" class="sammio-icon--rotate"></chevron-down-icon>
                                        </span>

                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content >
                                            <v-list-item v-if="statute.chapters[0].visible"
                                                         v-for="(chapter,j) in statute.chapters"
                                                         :key="'dt-' + i + '-' + j"
                                                         @click="onNavClick(i + 1, j + 1)"
                                                         v-bind:class="{active: isStatuteActive(i) && isChapterActive(j)}"
                                                         :aria-current="isStatuteActive(i) && isChapterActive(j) ? 'location' : 'false'"
                                            >
                                                <v-list-item-content>
                                                    {{ getChapterTitle(chapter) }}
                                                </v-list-item-content>
                                            </v-list-item>

                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </div>
                        </div>
                </aside>
                
                <a @click.prevent="focusCurrentSidebarStatute()" href="#active-aside-statute" id="skip-to-active-aside-statute">{{$t('sammio.statutes.side_navigation_go_to')}}</a>
                <section :class="getClassNames" v-if="!error" ref="article" id="sammio__element--main" tabindex="-1">
                    <article ref="sammioArticle">
                        <p class="mb-5" v-html="infoContent"></p>
                        <h1>{{$t('sammio.statutes.title')}}</h1>
                        <v-divider class="mb-5"></v-divider>
                        <sammio-statute-chapter
                                v-if="card === null"
                                :statuteTitle="currentStatute.title"
                                :statuteOrdinal="currentStatute.ordinal"
                                :chapterTitle="currentStatute.chapterTitle"
                                :chapterTitleReversed="currentStatute.chapterTitleReversed"
                                :sections="currentStatute.sections"
                                v-on:section-title-click="onSectionTitleClick"
                                v-on:initial-chapter-html-loaded="onInitialChapterHtmlLoaded"
                        >
                        </sammio-statute-chapter>
                        <sammio-card
                            v-else
                            :id="'card'"
                            :cardProps="card"
                            css-class="sammio-card bg-white p-3 mb-4 w-100"
                        >
                        </sammio-card>
                    </article>
                </section>
                <section class="col-md-8" v-else>
                    <sammio-errors
                            target="statutes"
                            :data="this.$store.getters.getErrors.data"
                    ></sammio-errors>

                </section>
            </div>
        </div>

        <v-navigation-drawer
                v-model="showMobileDrawer"
                app
                temporary
                width="99vw"
                v-if="getMobileStatus"
        >
            <v-btn class="btn-link border-0 p-0 m-0 text-black sammio__button--close_panel" @click="showMobileDrawer = false"><x-icon size="1.75x" ></x-icon><span class="sr-only">{{$t('sammio.close')}}</span></v-btn>
            <h4 class="sammio-panels__title p">{{$t('sammio.statutes.title')}}</h4>
            <v-expansion-panels
                    accordion
                    tile
                    v-model="openPanels"
                    width="74vw"

            >
                <v-expansion-panel
                        v-for="(statute,i) in statutes"
                        :key="'mob-' + i"
                >
                    <v-expansion-panel-header
                            hide-actions
                            @click="onNavClick(i + 1,1)"
                    >
                        {{statute.name}}
                        <span role="presentation" class="sammio-icon">
                                    <chevron-down-icon size="1.5x" class="sammio-icon--rotate"></chevron-down-icon>
                                </span>

                    </v-expansion-panel-header>
                    <v-expansion-panel-content >
                        <v-list-item v-if="statute.chapters[0].visible"
                                     v-for="(chapter,j) in statute.chapters"
                                     :key="'mob-' + i + '-' + j"
                                     @click="onNavClick(i + 1, j + 1)"
                                     v-bind:class="{active: isStatuteActive(i) && isChapterActive(j)}">
                            <v-list-item-content>
                                {{ getChapterTitle(chapter) }}
                            </v-list-item-content>
                        </v-list-item>

                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-navigation-drawer>
    </div>
</template>

<script>
    import {ChevronDownIcon, XIcon} from 'vue-feather-icons'
    import SammioActions from "../SammioActions";
    import SammioStatuteChapter from "./SammioStatuteChapter";
    import SammioErrors from '../SammioErrors'
    import SammioCard from '../SammioCard'
    import * as http from '../../store/http';
    import {i18n} from "../../translations/i18n";
    import {getCardFromSubsection, getInt} from "../../store/helpers";
    import layout from "../../shared/layout-mixin";


    export default {
        name: "SammioStatutes",
        props: {
            urlStatuteIndex: String,
            doScroll: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                statutes: [],
                currentStatute: {
                    title: '',
                    ordinal: 0,
                    chapterTitle: '',
                    chapterTitleReversed: '',
                    sections: []
                },
                openPanels: getInt(this.urlStatuteIndex) - 1,
                error: false,
                card: null,
                currentView: null,
                infoContent: this.getInfoContent()
            }
        },
        computed: {
            locale() {
                return i18n.locale
            }
        },
        components: {
            SammioActions,
            SammioStatuteChapter,
            SammioErrors,
            SammioCard,
            ChevronDownIcon,
            XIcon
        },
        mixins: [layout],
        mounted () {
            this.updateCurrentView()
            if (this.currentView.subsectionIndex != null) {
                this.fetchCard()
            }
            this.fetchStatutes()
        },
        methods: {
            isStatuteActive(i) {
              return (i === (this.currentView.statuteIndex - 1))
            },
            isChapterActive(i) {
                return (i === (this.currentView.chapterIndex - 1))
            },
            updateCurrentView() {
                const path = this.$router.currentRoute.path;
                let regexpPath = /\/saadokset\/(?<statuteIndex>\w+)\/(?<chapterIndex>\w+)\/(?<sectionIndex>\w+)\/?(?<subsectionIndex>\w*)/g
                let match = regexpPath.exec(path)
                if (match !== null) {
                    this.currentView = {
                        statuteIndex: getInt(match.groups.statuteIndex),
                        chapterIndex: getInt(match.groups.chapterIndex),
                        sectionIndex: getInt(match.groups.sectionIndex),
                        subsectionIndex: match.groups.subsectionIndex ? getInt(match.groups.subsectionIndex) : null
                    }
                } else {
                    this.currentView = {
                        statuteIndex: 1,
                        chapterIndex: 1,
                        sectionIndex: 1,
                        subsectionIndex: null
                    }
                }
            },
            onNavClick(statuteIndex, chapterIndex) {
                this.updateUrl(statuteIndex, chapterIndex, 1)
                this.loadStatuteContent(true)
                this.card = null
            },
            onSectionTitleClick(sectionIndex) {
                this.updateUrl(this.currentView.statuteIndex, this.currentView.chapterIndex, sectionIndex + 1)
                this.card = null
            },
            fetchCard() {
                http.get('/get-subsection', this.$store.state.portletId, this.currentView)
                    .then(response => {
                        this.card = getCardFromSubsection(response.data.subsection);
                        this.scrollCardIntoView()
                    })
                    .catch(error => {
                        this.error = true
                        this.$store.dispatch('setErrorMessages', { hasErrors: true, data: { type: 'cards', code: '', text: i18n.t('sammio.errors.common_error') } })
                    })
            },
            fetchStatutes() {
                let component = this;

                const statuteIndex = this.currentView.statuteIndex
                const chapterIndex = this.currentView.chapterIndex
                return http.get('/get-statutes', this.$store.state.portletId,
                    {
                        statuteIndex,
                        chapterIndex
                    })
                    .then(response => {
                        if (component.$data.statutes.length === 0) {
                            component.$data.statutes = response.data
                        } else {
                            component.$data.statutes[statuteIndex - 1] = response.data[statuteIndex - 1]
                        }
                        component.viewStatuteContent()
                        return Promise.resolve();
                    })
                    .catch(error => {
                        this.$store.dispatch('setErrorMessages', { hasErrors: true,  data: { type: 'statutes', code: '', text: i18n.t('sammio.errors.common_error') } })
                        this.error = true
                    })

            },
            loadStatuteContent(scroll = false, forceReload = false) {
                const statuteIndex = this.currentView.statuteIndex
                const chapterIndex = this.currentView.chapterIndex
                if ((this.statutes[statuteIndex - 1].chapters[chapterIndex - 1].sections.length === 0) || forceReload) {
                    this.fetchStatutes(statuteIndex, chapterIndex)
                        .then(() => {
                            this.viewStatuteContent(scroll)
                        })
                } else {
                    this.viewStatuteContent(scroll)

                }
            },
            viewStatuteContent(scroll = false) {

                let statute = this.statutes[this.currentView.statuteIndex - 1]
                let chapter = statute.chapters[this.currentView.chapterIndex - 1]
                this.currentStatute = {
                    title: statute.name,
                    ordinal: this.currentView.statuteIndex,
                    chapterTitle: chapter.name,
                    chapterTitleReversed: chapter.nameReversed,
                    sections: chapter.sections
                }

                let that = this
                this.$nextTick(function() {
                    MathJax.typeset(['.sammio-statute'])
                    if (scroll) {
                        that.scrollSectionIntoView()
                    }
                })

            },
            updateUrl(statuteIndex, chapterIndex, sectionIndex, subsectionIndex = null) {
                let path = `/saadokset/${statuteIndex}/${chapterIndex}/${sectionIndex}`
                if (subsectionIndex !== null) {
                    path = path + `/${subsectionIndex}`
                }
                if (path !== this.$router.currentRoute.path) {
                    if (i18n.locale !== 'fi') {
                        path = path + '?lang=' + i18n.locale
                    }
                    this.$router.push(path)
                }
                this.updateCurrentView()

            },
            onInitialChapterHtmlLoaded() {
                this.scrollSectionIntoView()
            },
            scrollSectionIntoView() {
                if ((this.currentView.sectionIndex === 1) && (this.doScroll)) {
                    let main = document.getElementById('sammio__element--main')
                    if (main) {
                        main.scrollIntoView()
                        main.focus();
                    }
                } else {
                    if (this.doScroll) {
                        let section = document.getElementById('section-' + this.currentView.statuteIndex + '-' + this.currentView.sectionIndex)
                        if (section) {
                            section.scrollIntoView()
                            section.focus();
                        }
                    }
                }
            },
            scrollCardIntoView() {
                this.$nextTick(function() {
                    let cardElement = document.getElementById('card')
                    if (cardElement) {
                        cardElement.scrollIntoView()
                    }
                })
            },
            focusCurrentSidebarStatute() {

                this.$nextTick(function() {

                    const asideElement = document.getElementById('sammio__element--aside');
                    const activeExpandedPanels = asideElement.getElementsByClassName('v-expansion-panel v-item--active');

                    // Check if main level "v-expansion-panel" is active (true if it or one of its child is active)
                    if (activeExpandedPanels[0]) {

                        // Check if list item or header button should be focused
                        const activeListItems = activeExpandedPanels[0].getElementsByClassName('v-list-item active');
                        if (activeListItems[0]) {
                            activeListItems[0].focus();
                            activeListItems[0].scrollIntoView();
                        } 
                        else {
                            const headerButton = activeExpandedPanels[0].getElementsByClassName('v-expansion-panel-header')[0];
                            headerButton.focus();
                            headerButton.scrollIntoView();
                        }
                    } else {
                        console.log("No focusable statutes found");
                        jQuery('#announcer').text(i18n.t('sammio.statutes.side_navigation_no_results'));
                    }
                })
            },
            getInfoContent() {
                http.get('/get-content', this.$store.state.portletId, {info: 'statutes'})
                    .then(response => {
                        this.infoContent = response.data.content
                    })
                    .catch(error => {
                        this.$store.dispatch('setErrorMessages', { hasErrors: true,  data: { type: 'statutes', code: '', text: i18n.t('sammio.errors.common_error') } })
                        this.error = true
                    })
            },
            getChapterTitle(chapter) {
                let title = chapter.name
                if (i18n.locale == "en") {
                    // e.g. "Chapter 1 General provisions"
                    title = this.capitalize(chapter.nameReversed);
                }
                return title;
            },
            capitalize(text) {
                const first = text[0].toUpperCase();
                const rest = text.slice(1);

                return first + rest;
            },
        },
        watch:{
            $route (to, from) {
                if (from && (from.name !== to.name) && (to.name.startsWith('statutes'))) { // coming from another view
                    this.updateCurrentView()
                    if (this.currentView.subsectionIndex != null) {
                        this.fetchCard()
                        this.openPanels = getInt(this.urlStatuteIndex) - 1
                    } else {
                        this.loadStatuteContent(true)
                    }
                }
                if (!to.name.startsWith('statutes')) {
                    this.card = null
                }
                this.fetchStatutes()

            },
            locale(lang) {
                if (this.$router.currentRoute.name.startsWith('statutes')) {
                    this.loadStatuteContent(false, true)
                    this.getInfoContent()
                }
            }
        }
    }
</script>

<style lang="scss">
    .sticky__container {
        position: relative;
    }
    .sammio__intersect--marker {
        display: block;
        width: 1px;
        height: 1px;
        margin: 0;
        padding: 0;
        opacity: 0;
        visibility: hidden;
    }

    .v-expansion-panel-header {
        position: relative;
        width: 100%;
        text-align: left;
        background: transparent;
        border: 0;

        .sammio-icon {
            position: absolute;
            right: 1em;
            top: .75em;
        }
    }

    .v-expansion-panel-header--active .sammio-icon > svg { transform: rotate(180deg); }

    /* NAVIGATION DRAWER */
    .v-navigation-drawer {
        -webkit-overflow-scrolling: touch;
        display: flex;
        flex-direction: column;
        left: 0;
        max-width: 100%;
        overflow: hidden;
        pointer-events: auto;
        top: 0;
        transition-duration: .2s;
        transition-timing-function: cubic-bezier(.4,0,.2,1);
        will-change: transform;
        transition-property: transform,visibility,width;


    }

    .theme--light.v-navigation-drawer {
        background-color: #fff;
    }

    .v-navigation-drawer--temporary {
        z-index: 11;
    }

    .v-navigation-drawer--fixed {
        position: fixed;
        background-color: white;
    }

    .v-navigation-drawer__content {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .v-navigation-drawer__border {
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: 1px;
    }

    .v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close), .v-navigation-drawer--temporary:not(.v-navigation-drawer--close) {
        box-shadow: 0 8px 10px -5px rgba(0,0,0,.2), 0 16px 24px 2px rgba(0,0,0,.14), 0 6px 30px 5px rgba(0,0,0,.12);
    }

    .theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {
        background-color: rgba(0,0,0,.12);
    }
    .v-sticky--element {
        position: fixed;
        top: 1rem;
    }
    .sammio__container--scrollable {
        position: relative;
        height: 97vh;
        overflow-y: scroll;
    }


</style>
